import type { TeaserProps } from './types/TeaserTypes'

import './Teaser.scss'

const columnsClasses: Record<number, string> = {
    1: 'one',
    2: 'two',
    3: 'three',
    4: 'four'
}

const Teaser = ({ columns, children }: TeaserProps) => {
    const columnClass = (columns && columnsClasses[columns]) || ''

    return (
        <div className={`teaser-wrapper ${columnClass}`}>
            {children}
        </div>
    )
}

export default Teaser